// extracted by mini-css-extract-plugin
export default {"editor":"crop_editor__H-JKl","banner":"crop_banner__02ghH","cropper":"crop_cropper__ng8Tv","slide-in-bottom":"crop_slide-in-bottom__b6qBa"};